module.exports = __webpack_public_path__ + "img/inge-v6-char-4.1c2b56a3.png";